module.exports = __webpack_public_path__ + "static/media/user_4.9a1e1090.png";